import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from "./slice/authSlice";

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
};

const appReducer = combineReducers({
    auth: authReducer
});

const rootReducer = (state, action) => {
    if (action.type === 'RESET_STORE') {
        return appReducer(undefined, action);
    }
    return appReducer(state, action);
};

export const persistedReducer = persistReducer(persistConfig, rootReducer);